module.exports = {
          srcSet: __webpack_public_path__ + "f7e24568dcbac141a366d87feaf82018-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "f7e24568dcbac141a366d87feaf82018-180.png",width: 180,height: 180}],
          src: __webpack_public_path__ + "f7e24568dcbac141a366d87feaf82018-180.png",
          toString:function(){return __webpack_public_path__ + "f7e24568dcbac141a366d87feaf82018-180.png"},
          
          width: 180,
          height: 180
        }